<template>
  <div v-if="this.$store.state.betgame.competition.id === 13" class="notification" style="margin-bottom: 24px;">
      <h1>{{ $t('dashboard.tournament_preview_title') }}</h1>
      <p>{{ $t('dashboard.match_preview_text_at') }}</p>
      <router-link :to="{name: 'rankings'}">
        <button>{{ $t('dashboard.button_view_rankings_total') }}</button>
      </router-link>
  </div>
  <div v-else-if="this.$store.state.betgame.competition.id === 115" class="notification" style="margin-bottom: 24px;">
    <h1>{{ $t('dashboard.tournament_preview_title') }}</h1>
    <p>{{ $t('dashboard.match_preview_text_ch') }}</p>
    <router-link :to="{name: 'rankings'}">
      <button>{{ $t('dashboard.button_view_rankings_total') }}</button>
    </router-link>
  </div>
  <div v-else-if="this.$store.state.betgame.competition.id === 122" class="notification" style="margin-bottom: 24px;">
    <h1>{{ $t('dashboard.tournament_preview_title') }}</h1>
    <p>{{ $t('dashboard.match_preview_text_gr') }}</p>
    <router-link :to="{name: 'rankings'}">
      <button>{{ $t('dashboard.button_view_rankings_total') }}</button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'PlayoffHint',
  components: {},
  data () {
    return {}
  },
  beforeCreate () {
  },
  created () {
  },
  mounted () {
  },
  computed: {},
  methods: {
  }
}
</script>

<style lang="scss">

</style>
